<!-- 订单状态 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector
      v-bind="config"
      v-model="orderStatus"
      type="orderStatus"
      clearable
      :multiple="config.multiple"/>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-订单状态',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '订单状态：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const orderStatus = useQuery('orderStatus', props.value);

    return {
      orderStatus,
    };
  },
};
</script>
